import api from '@/utils/api';
import {
    GET_MEDICAL_RECORD_BY_CUSTOMER,
    UPDATE_SPECIFIC_MEDICAL_RECORD,
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * 🔹 Lấy thông tin bệnh án theo khách hàng
 */
export const getByCustomer = (filter, customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/medical-records/customer/${customerId}`, { params: filter })
            .then(res => {
                dispatch({
                    type: GET_MEDICAL_RECORD_BY_CUSTOMER,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
};

/**
 * 🔹 Cập nhật hoặc tạo mới bệnh án
 */
export const updateMedicalRecord = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/medical-records/customer/${customerId}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_MEDICAL_RECORD,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Cập nhật bệnh án thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Có lỗi xảy ra khi cập nhật!');
                reject(err);
            });
    });
};

/**
 * 🔹 Duyệt bệnh án
 */
export const approveMedicalRecord = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/medical-records/approve/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_MEDICAL_RECORD,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã xác nhận bệnh án!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể duyệt bệnh án!');
                reject(err);
            });
    });
};

/**
 * 🔹 Hủy duyệt bệnh án
 */
export const unapproveMedicalRecord = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/medical-records/unapprove/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_MEDICAL_RECORD,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã hủy xác nhận bệnh án!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể hủy duyệt bệnh án!');
                reject(err);
            });
    });
};
